module.exports = __webpack_public_path__ + "static/saisons-734a06f53919322bf303dc96d26926a5.jpg";